<template>
    <div class="mt-14 md:mt-28" :class="pageClass">
        <nav-bar :show-logo-text="navBarShowLogoText" @onMenuClick="onNavbarMenuClick"/>
        <template v-if="isAgencyCentral">
            <div class="mx-auto justify-center">
                <div class="w-full">
                    <div class="bg-amber-100 p-3 text-center font-bold border-b border-grey-30">
                        You are logged in as Agency Central, caching disabled
                        <StaticSearchLink to="/internal/session_tracker/exit" class="text-blue-search-title hover:underline">[ exit ]</StaticSearchLink>
                    </div>
                </div>
            </div>
        </template>
        <slot></slot>
        <footer class="w-full px-4 flex flex-col gap-4 divide-solid mt-12 mb-4 lg:container">
            <horizontal-separator class="border-grey-30"/>
            <div class="w-full flex flex-row gap-2 justify-center">
                <a href="https://twitter.com/agencycentral" target="_blank">
                    <icon-twitter class="w-10 h-10"/>
                </a>
                <a href="https://facebook.com/agencycentral" target="_blank">
                    <icon-facebook class="w-10 h-10"/>
                </a>
            </div>
            <horizontal-separator class="border-grey-30"/>
            <div class="grid grid-cols-1 gap-4 text-center md:grid-cols-3 md:text-left">
                <div class="w-full">
                    <h4 class="text-grey-40 font-bold">Help</h4>
                    <ul>
                        <li class="text-blue-30">
                            <static-search-link to="/contact-us/articles/privacy-policy.htm">Privacy Policy</static-search-link>
                        </li>
                        <li class="text-blue-30">
                            <static-search-link to="/cookie-policy">Cookie Policy</static-search-link>
                        </li>
                    </ul>
                </div>
                <div class="w-full">
                    <h4 class="text-grey-40 font-bold">About Agency Central</h4>
                    <ul>
                        <li class="text-blue-30">
                            <static-search-link to="/contact-us/articles/about-us.htm">About Us</static-search-link>
                        </li>
                        <li class="text-blue-30">
                            <static-search-link to="/contactus/index.html">Contact Us</static-search-link>
                        </li>
                        <li class="text-blue-30">
                            <static-search-link to="/agencyarea/index.html">Advertise With Us</static-search-link>
                        </li>
                        <li class="text-blue-30">
                            <static-search-link to="/articles">Articles</static-search-link>
                        </li>
                    </ul>
                </div>
                <div class="w-full">
                    <h4 class="text-grey-40 font-bold">Agency Central Ltd</h4>
                    <p class="text-grey-40">
                        The Whitehouse,<br/>
                        Wilderspool Business Park,<br/>
                        Greenalls Avenue<br/>
                        Warrington<br/>
                        Cheshire,<br/>
                        WA4 6HL
                    </p>
                </div>
            </div>
            <horizontal-separator class="border-grey-30"/>
            <div class="w-full text-center text-grey-40">
                &copy; 2000 - {{ new Date().getFullYear() }} Agency Central Ltd. No part of this site may be copied,
                distributed or duplicated in any way without prior consent of the owner
            </div>
        </footer>
        <side-bar
            :open="sideBarOpen"
            @onCloseClick="onNavbarCloseClick"
        />
    </div>
</template>

<script>
import NavBar from "Components/NavBar/NavBar";
import SideBar from "Components/NavBar/SideBar";
import IconFacebook from "Components/Icons/IconFacebook";
import IconTwitter from "Components/Icons/IconTwitter";
import HorizontalSeparator from "Components/HorizontalSeparator";
import StaticSearchLink from "../StaticSearchLink.vue";
import { mapGetters, mapState } from "vuex";

export default {
    name: "LayoutPage",
    props: {
        navBarShowLogoText: {
            type: Boolean,
            default: true
        }
    },
    components: {
        HorizontalSeparator,
        IconTwitter,
        IconFacebook,
        SideBar,
        NavBar,
        StaticSearchLink,
    },
    data: function () {
        return {
            sideBarOpen: false,
        };
    },
    computed: {
        ...mapGetters('laravelSession', ['isAgencyCentral']),
        ...mapState('pagetext', ['pagetype']),
        pageClass: function() {
            let t = this.pagetype.toLowerCase();
            return (t != 'none' && t != '') ? 'pagetype-' + t : '';
        }
    },
    methods: {
        onNavbarMenuClick() {
            this.sideBarOpen = !this.sideBarOpen;
        },
        onNavbarCloseClick() {
            this.sideBarOpen = false;
        }
    }
}
</script>
